<template>
  <div class="relative flex w-full flex-col items-start">
    <p class="mb-4 font-sans text-[16px] text-black">{{ label }}</p>

    <div
      class="flex w-full cursor-pointer items-center justify-between rounded-lg border border-dashed border-blue-dark bg-[#F0F9FB] p-6 py-5"
      @click="copyToClipboard"
    >
      <span class="font-sans text-xl font-bold text-blue-dark">{{ code }}</span>
      <Copy class="h-5 w-5" />
    </div>

    <transition name="fade">
      <div
        v-if="copied"
        class="absolute bottom-[-40px] flex w-full items-center rounded-lg border border-blue-light bg-white px-6 py-4 shadow-md"
      >
        <Check />
        <span class="ml-2 font-sans text-xl text-black">
          {{ successMessage }}
        </span>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeUnmount } from 'vue'
import Check from './Icons/Check.vue'
import Copy from './Icons/Copy.vue'

interface CopyBoxProps {
  label?: string
  successMessage?: string
  code: string
}

const props = withDefaults(defineProps<CopyBoxProps>(), {
  label: '',
  successMessage: '',
})

const copied = ref(false)

let timeout:NodeJS.Timeout

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(props.code)
    copied.value = true

    // Hide message after 2 seconds
    timeout = setTimeout(() => {
      copied.value = false
    }, 2000)
  } catch (error) {
    console.error('Failed to copy:', error)
  }
}

onBeforeUnmount(() => {
  clearTimeout(timeout)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
